import { render, staticRenderFns } from "./public_edit.vue?vue&type=template&id=6ca431d0&scoped=true"
import script from "./public_edit.vue?vue&type=script&lang=js"
export * from "./public_edit.vue?vue&type=script&lang=js"
import style0 from "./public_edit.vue?vue&type=style&index=0&id=6ca431d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca431d0",
  null
  
)

export default component.exports